let cursor = document.getElementById('cursor');
let lastX = 0, lastY = 0;
let cursorX = 0, cursorY = 0;
let speed = 0.2; // Contrôle la vitesse de suivi

// Fonction d'animation pour le suivi fluide du curseur
function animateCursor() {    
    cursorX += (lastX - cursorX) * speed;
    cursorY += (lastY - cursorY) * speed;

    cursor.style.left = `${cursorX}px`;
    cursor.style.top = `${cursorY}px`;

    requestAnimationFrame(animateCursor);
}

// Écoute les mouvements de la souris
document.addEventListener('mousemove', function(e) {
    let scrollY = window.scrollY || document.documentElement.scrollTop;
    lastX = e.pageX;
    lastY = e.pageY - scrollY;
});

// Rétrécir et recentrer le curseur au clic
document.addEventListener("mousedown", () => {
    cursor.style.transform = "translate(-50%, -50%) scale(0.8)";
});

document.addEventListener("mouseup", () => {
    cursor.style.transform = "translate(-50%, -50%) scale(1)";
});

// Démarrer l'animation
animateCursor();
